export const isValidEmail = (string) =>
  string ? /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(string) : true;
